import { Component } from '@angular/core';

@Component({
  selector: 'll-exam-sections-payables',
  templateUrl: './ll-exam-sections-payables.component.html',
  styleUrl: './ll-exam-sections-payables.component.css'
})
export class LlExamSectionsPayablesComponent {

}
